const getPbErrorMessage = (error: unknown, fallback = 'Произошла ошибка'): string => {
  const value = error as {
    data?: {
      message?: string;
      data?: Record<string, { message?: string }>;
    };
    message?: string;
    response?: {
      message?: string;
      data?: {
        message?: string;
      };
    };
  };

  const fieldError = value?.data?.data
    ? Object.values(value.data.data).find(item => item?.message)?.message
    : undefined;

  return value?.data?.message
    || fieldError
    || value?.response?.data?.message
    || value?.response?.message
    || value?.message
    || fallback;
};

export { getPbErrorMessage };
